import {PageLink} from '../../../../_metronic/layout/core'
// import {useIntl} from 'react-intl'

export const AIBankerBreadcrum: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export const AIBankerQuestions: Array<any> = [
  {
    id: 1,
    value:
      'What are the most common mistakes startups make during the fundraising process, and how can I avoid them?',
  },
  {
    id: 2,
    value:
      'What are the latest trends in startup funding, and how should I position my business to align with investor preferences?',
  },
  {
    id: 3,
    value:
      'What types of investors (VCs, angel investors, etc.) are most likely to fund startups in my industry?',
  },
  {
    id: 4,
    value: 'What key elements should I emphasize in my pitch deck to attract investors?',
  },
]
